module.exports = __webpack_public_path__ + "assets/img/75f2-mq.svg";